module.exports = __webpack_public_path__ + "static/media/kik-blue.8555c5eb.svg";